import { render, staticRenderFns } from "./NewsMobileBanner.vue?vue&type=template&id=1039124e&scoped=true&"
import script from "./NewsMobileBanner.vue?vue&type=script&lang=js&"
export * from "./NewsMobileBanner.vue?vue&type=script&lang=js&"
import style0 from "./NewsMobileBanner.vue?vue&type=style&index=0&id=1039124e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1039124e",
  null
  
)

export default component.exports